import { ReducerBuilder } from "typescript-fsa-reducers";
import immer from "immer";

interface ReducerBuilderWithImmer<InS extends OutS, OutS> extends ReducerBuilder<InS, OutS> {
  caseWithoutImmer: ReducerBuilder<InS, OutS>["case"];
  casesWithoutImmer: ReducerBuilder<InS, OutS>["cases"];
}

function withImmer<InS extends OutS, OutS>(reducers: ReducerBuilder<InS, OutS>): ReducerBuilderWithImmer<InS, OutS> {
  const original = {
    case: reducers.case.bind(reducers),
    cases: reducers.cases.bind(reducers),
  };

  return Object.assign(reducers, {
    caseWithoutImmer: original.case,
    casesWithoutImmer: original.cases,
    case(actionCreator: any, handler: any) {
      return original.case(actionCreator, (state: any, payload: any) =>
        immer(state, state => {
          return handler(state, payload);
        })
      );
    },
    cases(actionCreators: any[], handler: any) {
      return original.cases(actionCreators, (state: any, payload: any) =>
        immer(state, state => {
          return handler(state, payload);
        })
      );
    },
  });
}

export default withImmer;



// WEBPACK FOOTER //
// ./frontend/src/lib/withImmer.ts